import { ref, useContext, watch } from '@nuxtjs/composition-api';
import { isEqual } from 'lodash-es';
import { useRouter } from './router';
import { useI18n } from './i18n';
import { SortEnum } from '~/graphql-types.gen';
import { Unpacked } from '~/types/utils';

export function useSortBy() {
  const { t } = useI18n();

  const options = [
    // { label: 'name', value: { name: SortEnum.Asc } },
    { label: t('mostPopular').toString(), value: undefined },
    { label: t('priceLowToHigh').toString(), value: { price: SortEnum.Asc } },
    { label: t('priceHighToLow').toString(), value: { price: SortEnum.Desc } },
    // { label: 'ratingHighToLow', value: { average_rating: SortEnum.Desc } },
    // { label: 'ratingLowToHigh', value: { average_rating: SortEnum.Asc } },
  ];

  const selectedOption = ref<Unpacked<typeof options> | undefined>(options[0]);

  const { route } = useRouter();
  const { app } = useContext();

  watch(selectedOption, newValue => {
    if (newValue) {
      app?.router
        ?.replace({
          query: {
            ...(route.value?.query || {}),
            sort: newValue.value ? JSON.stringify(newValue.value) : undefined,
          },
        })
        .catch((err: Error) => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
    }
  });

  watch(
    () => route,
    newRoute => {
      if (newRoute.value.query.sort) {
        const option = options.find(option =>
          isEqual(option.value, JSON.parse(newRoute.value.query.sort.toString()) as typeof options[number]['value'])
        );

        if (option) selectedOption.value = option;
      }
    },
    {
      immediate: true,
    }
  );

  return {
    options,
    selectedOption,
  };
}
